export default __webpack_public_path__ + "static/media/seller-carvago.398a8630.svg";